import React, { FC } from 'react';
import style from './style.module.less';
import { ToastModal } from '../toast-modal';
import TickIcon from './tick.svg?react';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export const MatterCreatedToast: FC<Props> = (props) => {
  const { isOpen, onClose } = props;

  return (
    <ToastModal
      isOpen={isOpen}
      onClose={onClose}
      title={'SUCCESS'}
      toastClassName={style.successToast}
    >
      <div className={style.successToastContent}>
        <div className={style.successIconWrapper}>
          <TickIcon className={style.successIcon} />
        </div>
        <div className={style.successToastText}>
          Matter created successfully.<br/>
          Remember to complete conflict of interest check!
        </div>
      </div>
    </ToastModal>
  );
};
